import React, { Component, MouseEvent } from "react";
import classnames from "classnames";

import { Icon } from "@formant/ui/component/common/Icon";

import { ActionButton } from "../Settings/ActionButton";
import * as styles from "./SoftCheck.scss";

export interface ISoftCheckProps {
    checked: boolean;
    ambiguous?: boolean;
    onToggle: (checked: boolean) => void;
    asActionButton?: boolean;
    tooltip?: string;
    dataTestId?: string;
}

export class SoftCheck extends Component<ISoftCheckProps> {
    public render() {
        const { checked, ambiguous, asActionButton, tooltip, dataTestId } =
            this.props;
        return (
            <div
                className={classnames(
                    styles["soft-check"],
                    checked && styles.checked,
                    !checked && styles.unchecked,
                    ambiguous && styles.ambiguous,
                )}
                onClick={this.toggle}
            >
                {asActionButton ? (
                    <ActionButton
                        icon="check"
                        data-tooltip={tooltip}
                        data-testid={dataTestId}
                    />
                ) : (
                    <Icon name="check" data-tooltip={tooltip} />
                )}
            </div>
        );
    }

    private toggle = (event: MouseEvent) => {
        if (event.button !== 0) {
            return;
        }
        event.stopPropagation();
        this.props.onToggle(!this.props.checked);
    };
}
